import React from "react";
import {observer} from "mobx-react";
import {ValidatedValue} from "../../../../helpers/validatedValue";
import {Autocomplete, createFilterOptions, FormControl, List, TextField} from "@mui/material";
import {AutocompleteDropDownModel} from "../../../models/autocompleteDropdown";
import Error from "../error/error";
import "./autocompleteDropdown.scss";
import "../dropDown/dropDown.scss";
import i18n from "../../../../i18n/i18n";
import ReloadButton from "../reloadButton/reloadButton";

interface AutocompleteDropDownProps {
    onChange?: (newValue: any) => void;
    validatedValue: ValidatedValue<string | null>;
    options: AutocompleteDropDownModel[];
    label: string;
    testId: string;
    height?: number;
    className?: string;
    disabled?: boolean | false;
    error?: string;
    reloadFunc?: () => void;
    isNoRequired?: boolean;
}

function AutocompleteDropDown(props: AutocompleteDropDownProps) {
    const selectedElement = props.options.find((option) => option.id === props.validatedValue.value) || null;

    return (
        <div className="dropdown-form">
            <FormControl
                className={`dropdown ${props.className || ""} ${displayError() || displayErrorWhenDataNotLoaded() ? "has-error" : ""} ${displayErrorWhenDataNotLoaded() && props.isNoRequired ? "no-required" : ""}`}
                data-testid={props.testId}
            >
                <Autocomplete
                    value={selectedElement}
                    className="autocomplete"
                    id={`${props.testId}-autocomplete`}
                    data-testid={`${props.testId}-autocomplete`}
                    options={props.options}
                    getOptionLabel={(option) => option.label}
                    renderOption={(props, option) => (
                        <List {...props} style={{display: "flex",alignItems: "flex-start", textAlign: "left"}} component="li" key={option.id} data-testid={`${option.id}-option`}>
                            {option.renderOption ? option.renderOption : option.label}
                        </List>
                    )}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            id={`${props.testId}-input`}
                            label={props.label}
                            error={displayError()}
                        />
                    )}
                    onChange={(_, newValue) => {
                        props.validatedValue.clearValidation();
                        props.validatedValue.setValue(newValue ? newValue.id : null);

                        if (props.onChange) {
                            props.onChange(newValue);
                        }
                    }}
                    onBlur={validate}
                    onClose={validate}
                    sx={{maxHeight: props.height || 300}}
                    filterOptions={createFilterOptions({
                        limit: 500
                    })}
                    disabled={props.disabled}
                />
                {displayError() && (
                    <Error message={props.validatedValue.errorMessage}/>
                )}
                {displayErrorWhenDataNotLoaded() && (
                    <Error message={i18n.t("defaultNoDataLoadErrorMessage", {messageSuffix: props.error})}/>
                )}
            </FormControl>
            {displayErrorWhenDataNotLoaded() && props.reloadFunc && (
                <ReloadButton
                    className={props.isNoRequired ? "no-required" : ""}
                    reloadFunc={props.reloadFunc}
                    testId={`${props.testId}-reload`}
                />
            )}
        </div>
    );

    function validate() {
        props.validatedValue.validate();
    }

    function displayError(): boolean {
        return !!props.validatedValue.errorMessage;
    }

    function displayErrorWhenDataNotLoaded(): boolean {
        return !!props.error;
    }
}

export default observer(AutocompleteDropDown);